import React, { useCallback } from 'react';
import './Selector.css';
import IntegerSelector from "../IntegerSelector/IntegerSelector";
import { ISubscription } from '../Calculator/Calculator';

const selectorIcon = "images/Selector.png";

interface IDates {
  [key: string]: string;
}

const dates: IDates = {
  1: "1 месяц",
  3: "3 месяца",
  6: "6 месяцев",
  12: "12 месяцев",
  60: "5 лет",
  1200: "Навсегда",
};

interface IProps {
  availableSubscriptions: ISubscription[]
  activeSubscription?: ISubscription
  onSelect: (subscription: ISubscription) => void
}

const SubscriptionSelect: React.FC<IProps> = ({
  availableSubscriptions, activeSubscription, onSelect,
}) => {
  console.log('activeSubscription', activeSubscription)

  // const handleCountChange = useCallback((newValue: number) => {
  //   if (newValue >= 3) {
  //     setCount(newValue);
  //   }
  // }, [])

  const onSelectChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target
    onSelect(availableSubscriptions.find(
      availableSubscription => availableSubscription.id === Number(value)
    ) || availableSubscriptions[0])
  }, [onSelect, availableSubscriptions])

  return (
    <div>
      {/* {showCountSelector && <IntegerSelector className="IntegerSelector" onChange={handleCountChange} />} */}
      <div className="Selector">
        <div>
          <select
            title='select'
            onChange={onSelectChange}
            className="InputDate"
            value={activeSubscription?.id}
          >
            {
              availableSubscriptions.map((subscription, key) => (
                <option key={key} value={subscription.id}>
                  {dates[subscription.months.toString()]} {subscription.isPremium && '(Premium)'}
                </option>
              ))
            }
          </select>
          {activeSubscription && dates[activeSubscription.months]}
          {/* {activeSubscription?.isPremium && '(Premium)'} */}
          <img alt='select' className="SelectorImage" src={selectorIcon} />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSelect;
